<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeFace.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeFace.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.codeFace')">
          <qd-taginput v-model="critereRecherche.codesFace" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.codeMateriel')">
          <qd-taginput v-model="critereRecherche.codesMateriel" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.codeBail')">
          <qd-taginput v-model="critereRecherche.codesBail" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.nonCommercialisable')">
          <b-select v-model="critereRecherche.nonCommercialisable">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.motifNonCommercialisation')">
          <qd-taginput v-if="motifNonComTags"
                      v-model="motifsNonComSelected"
                      :data="motifNonComTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredMotifNonComTags"
                      @input="getMotifNonComTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.format')">
          <qd-taginput v-if="formatTags"
                      v-model="formatSelected"
                      :data="formatTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredFormatTags"
                      @input="getFormatTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.typeMateriel')">
          <qd-taginput v-if="materielTypeTags"
                      v-model="materielTypeSelected"
                      :data="materielTypeTags"
                      type="is-primary"
                      icon="magnify"
                      autocomplete
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredMaterielTypeTags"
                      @input="getMaterielTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.typeDispositif')">
          <qd-taginput v-if="dispositifTypeTags"
                      v-model="dispositifTypeSelected"
                      :data="dispositifTypeTags"
                      type="is-primary"
                      autocomplete
                      open-on-focus
                      icon="magnify"
                      field="libelle"
                      @typing="getFilteredDispositifTypeTags"
                      @input="getDispositifTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.typeSupport')">
          <qd-taginput v-if="supportTypeTags"
                      v-model="supportTypeSelected"
                      :data="supportTypeTags"
                      type="is-primary"
                      autocomplete
                      icon="magnify"
                      open-on-focus
                      field="libelle"
                      @typing="getFilteredSupportTypeTags"
                      @input="getSupportTypeTag">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <libelle-tag-input
                      :label="$t('listeFace.filtre.etat')"
                      :items="constantes.ETAT_DISPOSITIF_PUBLICITAIRE"
                      v-model="etatSelected">
        </libelle-tag-input>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.dateMontage')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesMontage.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeContrat.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesMontage.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.dateDemontage')">
          <div class="columns is-vcentered" >
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesDemontage.dateDebut"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
            <span class="column is-1">{{$t('listeFace.filtre.au')}}</span>
            <b-datepicker show-week-number
                          class="column"
                          icon="calendar-today"
                          :editable="true"
                          v-model="datesDemontage.dateFin"
                          position="is-bottom-left"
                          :nearby-selectable-month-days="true">
            </b-datepicker>
          </div>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.adresse')">
          <b-input v-model="critereRecherche.adresse">
          </b-input>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.ville')">
          <ville-tag-input-auto-complete
                :critere-recherche="critereRecherche"
                table-name="Tiers"/>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.agglomerations')">
          <qd-taginput v-model="critereRecherche.agglomerations" type="is-primary">
          </qd-taginput>
        </b-field>
      </div>
      <div class="column is-12 pdb-0">
        <b-field :label="$t('listeFace.filtre.actif')">
          <b-select v-model="critereRecherche.actif">
            <option :value="null"></option>
            <option :value="true"> {{ $t('general.oui') }}
            </option>
            <option :value="false"> {{ $t('general.non') }}
            </option>
          </b-select>
        </b-field>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()">
        {{$t('listeFace.filtre.actions.appliquer')}}
      </button>
      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()">
        {{$t('listeFace.filtre.actions.reinitialiser')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_CRITERE } from '@/store/modules/gabed/face-bailleur-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import genererCritereRechercheFaceByBailleur from '@/services/gabed/face/genererCritereRechercheFaceByBailleur';
import VilleTagInputAutoComplete from '@/components/commun/ville/villeTagInputAutoComplete';
import libelleTagInput from '@/components/general/tagInput/libelleTagInput';

const FaceBailleur = createNamespacedHelpers('faceBailleur');
const Parametres = createNamespacedHelpers('parametres');

export default {
  components: {
    libelleTagInput,
    VilleTagInputAutoComplete,
  },
  data() {
    return {
      critereRecherche: null,
      listeMotifNonComBase: [],
      motifsNonComSelected: [],
      motifNonComTags: null,
      formatTags: null,
      formatSelected: [],
      formatBase: [],
      materielTypeTags: null,
      materielTypeSelected: [],
      materielTypeBase: [],
      dispositifTypeTags: null,
      dispositifTypeSelected: [],
      dispositifTypeBase: [],
      supportTypeTags: null,
      supportTypeSelected: [],
      supportTypeBase: [],
      datesMontage: {
        dateDebut: null,
        dateFin: null,
      },
      datesDemontage: {
        dateDebut: null,
        dateFin: null,
      },
      constantes: {
        ETAT_DISPOSITIF_PUBLICITAIRE,
      },
      etatSelected: [],
    };
  },
  computed: {
    ...FaceBailleur.mapGetters({
      criteresRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    motifsNonCom() {
      return this.parametre(PARAMETRES_KEYS.faceMotifNonCom).filter(motif => motif.actif);
    },
    format() {
      return this.parametre(PARAMETRES_KEYS.materielFormat)
        .filter(el => el.actif);
    },
    materielType() {
      return this.parametre(PARAMETRES_KEYS.materielType).filter(m => m.actif);
    },
    dispositifType() {
      return this.parametre(PARAMETRES_KEYS.dispositifType);
    },
    supportType() {
      return this.parametre(PARAMETRES_KEYS.dispositifSupport).filter(s => s.actif);
    },
  },
  methods: {
    ...FaceBailleur.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    viderCritere() {
      this.datesDemontage = {
        dateDebut: null,
        dateFin: null,
      };
      this.datesMontage = {
        dateDebut: null,
        dateFin: null,
      };
      this.formatSelected = [];
      this.materielTypeSelected = [];
      this.supportTypeSelected = [];
      this.dispositifTypeSelected = [];
      this.etatSelected = [];
      this.motifsNonComSelected = [];
      this.critereRecherche = cloneDeep(genererCritereRechercheFaceByBailleur());
      this.initializeAutoComplete();
    },
    async appliquerCritere() {
      this.critereRecherche.datesMontage = this.datesMontage;
      if (!this.critereRecherche.datesMontage.dateDebut
        && !this.critereRecherche.datesMontage.dateFin) {
        this.critereRecherche.datesMontage = null;
      }
      this.critereRecherche.datesDemontage = this.datesDemontage;
      if (!this.critereRecherche.datesDemontage.dateDebut
        && !this.critereRecherche.datesDemontage.dateFin) {
        this.critereRecherche.datesDemontage = null;
      }
      this.critereRecherche.typesSupport = this.supportTypeSelected.map(el => { return el.id; });
      this.critereRecherche.typesDispositif = this.dispositifTypeSelected.map(el => {
        return el.id;
      });
      this.critereRecherche.typesMateriel = this.materielTypeSelected.map(el => {
        return el.id;
      });
      this.critereRecherche.formatsId = this.formatSelected.map(el => { return el.id; });
      this.critereRecherche.etatsFace = this.etatSelected.map(el => { return el.value; });
      this.critereRecherche.motifNonCommercialisableIds = this.motifsNonComSelected.map(m => {
        return m.id;
      });
      await this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    getFilteredMotifNonComTags(text) {
      this.getMotifNonComTag();
      this.motifNonComTags = this.motifNonComTags.filter((motifNonCom) => {
        return motifNonCom.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getMotifNonComTag() {
      this.motifNonComTags = this.listeMotifNonComBase.filter((motifNonCom) => {
        return !this.motifsNonComSelected.map(a => a.id).includes(motifNonCom.id);
      });
    },
    getFilteredFormatTags(text) {
      this.getFormatTag();
      this.formatTags = this.formatTags.filter((format) => {
        return format.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getFormatTag() {
      this.formatTags = this.listeFormatBase.filter((format) => {
        return !this.formatSelected.map(a => a.id).includes(format.id);
      });
    },
    getFilteredMaterielTypeTags(text) {
      this.getMaterielTypeTag();
      this.materielTypeTags = this.materielTypeTags.filter((materiel) => {
        return materiel.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getMaterielTypeTag() {
      this.materielTypeTags = this.materielTypeBase.filter((materiel) => {
        return !this.materielTypeSelected.map(a => a.id).includes(materiel.id);
      });
    },
    getFilteredDispositifTypeTags(text) {
      this.getDispositifTypeTag();
      this.dispositifTypeTags = this.dispositifTypeTags.filter((dispo) => {
        return dispo.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getDispositifTypeTag() {
      this.dispositifTypeTags = this.dispositifTypeBase
        .filter((dispo) => {
          return !this.dispositifTypeSelected.map(a => a.id).includes(dispo.id);
        })
        .filter(dispo => dispo.actif);
    },
    getFilteredSupportTypeTags(text) {
      this.getSupportTypeTag();
      this.supportTypeTags = this.supportTypeTags.filter((support) => {
        return support.libelle.toLowerCase().indexOf(text.toLowerCase()) >= 0;
      });
    },
    getSupportTypeTag() {
      this.supportTypeTags = this.supportTypeBase.filter((support) => {
        return !this.supportTypeSelected.map(a => a.id).includes(support.id);
      });
    },
    getFilteredAgenceTags(text) {
      this.getAgenceTag();
      this.agenceTags = this.agenceTags.filter((agence) => {
        return agence.libelleAgence.toLowerCase()
          .indexOf(text.toLowerCase()) >= 0;
      });
    },
    getAgenceTag() {
      this.agenceTags = this.listeAgenceBase.filter((agence) => {
        return !this.agenceSelected.map(a => a.agenceId).includes(agence.agenceId);
      });
    },
    initializeAutoComplete() {
      if (this.critereRecherche.formatsId) {
        this.formatSelected = this.listeFormatBase.filter((c) => {
          return this.critereRecherche.formatsId.includes(c.id);
        });
      }
      this.getFormatTag();

      this.materielTypeBase = this.materielType;
      if (this.critereRecherche.typesMateriel) {
        this.materielTypeSelected = this.materielTypeBase.filter((c) => {
          return this.critereRecherche.typesMateriel.includes(c.id);
        });
      }
      this.getMaterielTypeTag();

      if (this.critereRecherche.typesDispositif) {
        this.dispositifTypeSelected = this.dispositifTypeBase.filter((c) => {
          return this.critereRecherche.typesDispositif.includes(c.id);
        });
      }
      this.getDispositifTypeTag();

      if (this.critereRecherche.typesSupport) {
        this.supportTypeSelected = this.supportTypeBase.filter((c) => {
          return this.critereRecherche.typesSupport.includes(c.id);
        });
      }
      this.getSupportTypeTag();

      if (this.critereRecherche.etatsFace) {
        this.etatSelected = this.constantes.ETAT_DISPOSITIF_PUBLICITAIRE.filter((c) => {
          return this.critereRecherche.etatsFace.includes(c.value);
        });
      }

      if (this.critereRecherche.motifNonCommercialisableIds) {
        this.motifsNonComSelected = this.listeMotifNonComBase.filter((motif) => {
          return this.critereRecherche.motifNonCommercialisableIds.includes(motif.id);
        });
      }
      this.getMotifNonComTag();
    },
    async initializeFiltre() {
      this.critereRecherche = cloneDeep(this.criteresRechercheFromStore);
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadParametres([
          PARAMETRES_KEYS.faceMotifNonCom,
          PARAMETRES_KEYS.materielFormat,
          PARAMETRES_KEYS.materielType,
          PARAMETRES_KEYS.dispositifType,
          PARAMETRES_KEYS.dispositifSupport,
        ]);
        this.listeFormatBase = cloneDeep(this.format);
        this.materielTypeBase = cloneDeep(this.materielType);

        this.dispositifTypeBase = cloneDeep(this.dispositifType);

        this.supportTypeBase = cloneDeep(this.supportType);
        this.listeMotifNonComBase = cloneDeep(this.motifsNonCom);

        this.listeEtatBase = cloneDeep(this.listEtat);

        if (this.critereRecherche.datesMontage) {
          this.datesMontage = cloneDeep(this.critereRecherche.datesMontage);
        }
        if (this.critereRecherche.datesDemontage) {
          this.datesDemontage = cloneDeep(this.critereRecherche.datesDemontage);
        }
        this.initializeAutoComplete();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw (e);
      }
    },
  },
  async mounted() {
    await this.initializeFiltre();
  },
};
</script>
